import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap';
import {  FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';
import * as moment from 'moment';
import { BsModalService } from 'ngx-bootstrap';
import swal from 'sweetalert2';
import { SalesBillentryModel } from '../../../model/index';
import { SalesBillentryService, SubscribeService } from '../../../services/index';
import { ThermalSpareBill } from '../../../shared/print/thermal.spare.bill';
import { Store } from '@ngrx/store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';


@Component({
    selector: 'salesbillentry-tab',
    templateUrl: './salesBillentry.component.html',
})

export class SalesBillentryComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public salesbillentrydata: any[] = [];
    branchList: any[] = [];
    isLoadMask: Promise<any>;
    salesbillentryData: SalesBillentryModel[];
    filteredBranch: Observable<any[]>;
    isLoading: boolean = false;
    subscribeAuth;

    constructor(public store: Store<fromRootStore.State>, private salesbillentryService: SalesBillentryService, public subscribeService: SubscribeService, private modalService: BsModalService, private sanitizer: DomSanitizer) { 
        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        function hasValidBranch(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                retVal = { inValidBranch: true };
            }
            return retVal;
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);
    }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'desc'
    };
    filterData = {
        "search_name": "",
        "from_date": new Date(),
        "to_date": new Date(),
        "transaction_type" : 'ALL',
        "user_role_type" : '',
        "other_branch_bill" : false,
        "usertype" : '',
        "branch" : ''
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('salesBillentryTable') salesBillentryTable: any;
    branchCtrl: FormControl;
    columns = [];
    toggleCol = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    transTypeList = ["ALL", "NORMAL", "TRIAL"];
     printConfig: any = {
        title: this.title,
        columns: [],
        rows: []
    };
    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate, cellClass: 'cell-center' },
            { name: 'Bill No', prop: 'auto_no', width: 80, minWidth: 80, maxWidth: 80, cellClass: 'cell-right' },
            { name: 'Date', prop: 'disp_date', width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-center' },
            { name: 'Client ID', prop: 'client_no', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Client Name', prop: 'client_name',width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Bill Type', prop: 'transaction_type',width: 120, minWidth: 120, maxWidth: 120,page_prop: 'SpareEMI' },
            { name: 'Action', prop: 'sno', width: 350, minWidth: 350, maxWidth: 350, sortable: false, cellTemplate: this.editDeleteTemplate }
        ];

        if(this['params']['tabParams'] == 'Spare Bill' || this['params']['tabParams'] == 'EMI' ){
            var evens = _.remove(this.columns, function(obj) {
                return obj['page_prop'] == 'SpareEMI'
            });
        }
        this.toggleCol = Object.assign({}, this.columns);

        this.pageCallback({ offset: 0 });
        //THIS WILL WORK WHEN BILL SAVED IN OTHER TAB
        this.subscribeService.publishReloadSalesBillentryListGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });

        this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.filterData.user_role_type = auth['user_role_type'];
                this.filterData.usertype = auth['usertype'];
                this.filterData.branch = auth['branch_id'];
            }
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                this.store.dispatch(new commonActions.LoadAllBrand());
                this.branchList = res.data;


                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
            //this.displayBranchFn(this.clientdata['branch']);
            this.branchCtrl.setValue(this.salesbillentrydata['branch']);
        });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getSalesbillentryList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getSalesbillentryList();
    }
    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);

    }
    clearFilter(): void {
        this.filterData = {
            "search_name": "",
            "from_date": new Date(),
            "to_date": new Date(),
            "transaction_type" : "ALL",
            "user_role_type" : "",
            "other_branch_bill" : false,
            "usertype" : '',
            "branch" : ''
        };
        this.applyFilter();
    }
    applyFilter(): void {
        this.filterPanel.close();
        if(this.filterData['other_branch_bill'] == true){
            this.filterData['branch'] = '';
        }
        this.getSalesbillentryList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getSalesbillentryList();
    }
    getSalesbillentryList(): void {
        let that = this,
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderDir: `${this.page.orderDir}`,
                search_name: this.filterData['search_name'],
                transaction_type: this.filterData['transaction_type'],
                other_branch_bill: this.filterData['other_branch_bill'],
                branch: this.filterData['branch'],
                from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
                to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
                from_page: this['params']['tabParams'],
                mode: this['params']['mode']
            };
        this.isLoadMask = this.salesbillentryService
            .getSalesbillentryList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.salesbillentrydata = res.data;
            });
    }


    addSalesbillentry(mode: string, row: any): void {

        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'bill_id': '',
                'mode': mode
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
        } else if (mode == "View") {
            row['mode'] = mode;
        } else if (mode == "HvConvertToNormal") {
            row['mode'] = mode;
        }

        row['user_role_type'] = this.filterData.user_role_type;
        row['usertype'] =  this.filterData.usertype;  
        row['branchName'] =  this.filterData.branch;
        row['date'] = moment(this.filterData['from_date']).format('YYYY-MM-DD');
        that.subscribeService.subScribeTabID('Transaction', 'AddEditSalesBillentryComponent', row, this['params']['tabParams']);
    }
   
    goToServicewalkin(row: any): void {     
        row['mode'] = 'Add';
        row['from_page'] = 'company_service';
        row['walk_in_type'] = 'Service';
        this.subscribeService.subScribeTabID('Transaction', 'AddServiceWalkInComponent', row, 'Service Walk-in');
    }
    
    onDeleteSalesbillentry(row: any): void {
        let that = this,
        params = {
            bill_id: row.bill_id,
            client_id: row.client_id,
            bill_type: row.bill_type,
            adv_bill_ids: row.adv_bill_ids,
            type: row.type
        };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Sales Bill EntryDetails, No - ' + row['auto_no'],
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.loadingIndicator = true;
            that.isLoadMask = that.salesbillentryService
                .deleteSalesBillentry(params)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getSalesbillentryList();
                        swal(
                            'DELETED',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {

        })
    }
     @ViewChild('thermalPreviewModal') thermalPreviewModal: TemplateRef<any>;
    thermalPreviewRef: BsModalRef;
    thermalHtml: string = '';
    thermalSafeHtml: SafeHtml = '';
    thermalPrinting: boolean = false;
    @ViewChild('printPage') printPage;
    onPrintReport(row:any) {
        this['tabparams']="Advance";
        let that = this;
        this.printConfig = {
            type: this.title,
            title: 'SOUNDS GOOD HEARING CARE',
            subTitle: this.title,
            rows: row,
            columns: that.columns

           /*  fromdate: that.datePipe.transform(that.filterData['from_date'], 'dd-MM-yyyy'),
            todate: that.datePipe.transform(that.filterData['date'], 'dd-MM-yyyy') */
        }

        setTimeout(() => {
            that.printPage.printPreview();
        }, 100);
        /*setTimeout(() => {
            that.filterPanel.close();
        }, 100);*/
    }

    thermalPrintData: any = null;
    onThermalPrint(row: any) {
        this.salesbillentryService.getSpareBillPrintData({ bill_id: row.bill_id })
            .then((res: any) => {
                if (res && res.success) {
                    // Pre-compute MRP-based values so both preview HTML and local print service use them
                    const transformedDet = (res.det || []).map((item: any) => {
                        const mrp = parseFloat(item.mrp || 0);
                        const qty = parseFloat(item.machine_qty || 0);
                        return Object.assign({}, item, {
                            rate: item.free_item === 'Yes' ? item.rate : mrp,
                            machine_price: item.free_item === 'Yes' ? item.machine_price : parseFloat((mrp * qty).toFixed(2))
                        });
                    });
                    const grossFromMrp = transformedDet.reduce((sum: number, item: any) => {
                        return item.free_item === 'Yes' ? sum : sum + parseFloat(item.machine_price || 0);
                    }, 0);
                    const transformedData = Object.assign({}, res.data, { gross_total: parseFloat(grossFromMrp.toFixed(2)) });
                    this.thermalPrintData = { data: transformedData, det: transformedDet, branches: res.branches || [], logo: res.logo || '' };
                    this.thermalHtml = ThermalSpareBill.buildHtml(transformedData, transformedDet, res.branches || [], res.logo || '');
                    this.thermalSafeHtml = this.sanitizer.bypassSecurityTrustHtml(this.thermalHtml);
                    this.thermalPrinting = false;
                    this.thermalPreviewRef = this.modalService.show(this.thermalPreviewModal, { class: 'modal-md' });
                }
            });
    }

    downloadThermalPdf() {
        const pdfHtml = this.thermalHtml.replace(
            '</style>',
            '@media print{@page{size:80mm auto;margin:0;}body{margin:0;}}</style>'
        );
        const win = window.open('', '_blank');
        if (!win) { return; }
        win.document.open();
        win.document.write(pdfHtml);
        win.document.close();
        win.onload = () => { win.focus(); win.print(); };
    }

    confirmThermalPrint() {
        this.thermalPrinting = true;
        fetch('http://localhost:3000/api/thermalPrint', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ data: this.thermalPrintData })
        })
        .then(r => r.json())
        .then((result: any) => {
            this.thermalPrinting = false;
            if (result.success) {
                this.thermalPreviewRef.hide();
            } else {
                swal('Print Failed', result.msg || 'Thermal printer error.', 'error');
            }
        })
        .catch(() => {
            this.thermalPrinting = false;
            swal('ERROR', 'Thermal print service not available. Ensure local service is running on port 3000.', 'error');
        });
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch)));
    }

    displayBranchFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            let branchObj = _.find(this.branchList, { 'branch_id': branchID });
            return branchObj['branch_name'];
        }
        return '';
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/salesBillentry/salesBillentry.component.ts